import React, { useEffect, useState, useRef } from 'react';
import { useBlogContext } from '../../fetchdata/BlogContext';
import axiosInstance from '../../axiosInstance';
import messageAlertSound from '../../assets/audio/preview.mp3';
import { Link,useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import SlideButton from "react-slide-button";
import getDecryptData from '../../helper/getDecryptData';

const LiveRequest = () => {
  
  const decryptdatajson = getDecryptData();

   const myid = decryptdatajson?._id;
   

    const { AllRequestReq,removeRequest,  allRemoveId, setAllRemoveId } = useBlogContext();
    const [Loading, setLoading] = useState(true);
    const [Mybooking, setMybooking] = useState([]);
    const [FoundBook, setFoundBook] = useState(false);
    // const [allRemoveId, setAllRemoveId] = useState([]);
 

    useEffect(() => {

        const fetchLiveBooks = async () => {
            if (AllRequestReq && AllRequestReq.length !== 0) {
        

const updatedOrders = AllRequestReq.filter(order =>
  order.userId.includes(myid)
);
                 setMybooking(updatedOrders);
              // setMybooking(AllRequestReq);
              console.log('AllRequestReq',AllRequestReq)
                setFoundBook(true);

             if(updatedOrders.length !== 0 ){
       const sound = new Audio(messageAlertSound);
              sound.play();
             }

                // setLoading(true);
                // try {
                //     const response = await axiosInstance.get(`/get-all-Book/${DriverId}`);
                //     const { success, Bookings } = response.data;
                //     console.log('live data', Bookings);
                //     const reversedBookings = Bookings.reverse();

                //     setMybooking(Bookings);
                // } catch (error) {
                //     console.error('Error during login:', error);
                // } finally {
                //     setLoading(false);
                // }
            }
        };

        fetchLiveBooks();

     }, [AllRequestReq]);

    const navigate = useNavigate();


 

        const [error, setError] = useState(null);
    
      const AcceptOrder = async (Order,id) => {
    
     
        let updatedFormData;
    
        updatedFormData = {
          Order,
          OrderId: id,
        };
    
     
        try { 
    
          await toast.promise(
            axiosInstance.post(`/accept-Request`, updatedFormData),
            {
              loading: "Accept Request...", // Loading message
              success: "Accept Request successfully!", // Success message
              error: "Failed to Accept Request", // Error message
            }
          );
   
        //  navigate('/purchase/leads');
    
        } catch (error) {
          console.error("Error On Added Lead:", error);
           setError(error.response?.data?.message || "An unknown error occurred");
          toast.error(error.response.data.message);
         }finally{
          removeOrders(id)
         }
      };
    
    

    const CloseFoundBook = () => {
        console.log("close");
        setFoundBook(false);
        removeRequest();
    };


    //  🧹 Remove all orders whose orderId is in allRemoveId
const removeOrders = (id) => {
  // const updatedRemoveIds = [...allRemoveId, id]; // Add new id to the array
  // setAllRemoveId(updatedRemoveIds); // Update state

  // const updatedOrders = AllRequestReq.filter(order => !updatedRemoveIds.includes(order.orderId));
  // setMybooking(updatedOrders);
};

    return (
    <> 

 {(FoundBook && Mybooking.length !== 0) && (

<>
<div className='toast-wrap'>  
     <div
  className="toast fade show my-toast-Book bg-light"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
  data-bs-delay={3000}
  data-bs-autohide="false"
>

  <div className="toast-body">

 
 <div className='m-0 overflow-y-scroll pe-1' style={{maxHeight:'60vh'}}>
 {Mybooking.map((booking, index) => (
          <div className="card p-3 mb-2" key={index}>
            <h5 className='fw-bold text-success'> <i className="fa fa-check-circle text-success me-1"/> New Service Request</h5>
           <hr/>
             <p className='fw-bold small m-0 mt-2'>
          Order ID:    {booking.id}
        
      </p>
           <h6 className='text-success' >Sevice Summary</h6>
           <div className='mb-2'>
        <table className='table table-bordered table-sm mb-0'>
          <thead>
            <tr>
              <th>Title</th>
              <th>Qty</th>
              <th>Price</th>
              
            </tr>
          </thead>
          <tbody>
            {booking.items.map((item, itemIndex) => (
              <tr key={itemIndex}>
                <td>{item.title}</td>
                <td>{item.quantity}</td>
                <td>₹{item.price}</td>
               </tr>
            ))}
          </tbody>
          <tfoot>
  <tr>
    <td colSpan="2" className="text-end fw-bold">Grand Total</td>
    <td className="fw-bold">
      ₹{booking.items.reduce((acc, item) => acc + (item.price * item.quantity), 0).toFixed(2)}
    </td>
  </tr>
</tfoot>

        </table>
      </div>
     
            <div className="w-100">
              
              <p> <b> Note:</b> This service will be added to your order after you confirm.</p>


                   <SlideButton
                                      mainText={"Slide To Confirm"}
                                      overlayText={"Loading..."}
                                      classList="my-class text-center startride m-0"
                                      caretClassList="my-caret-class"
                                      overlayClassList="my-overlay-class"
                                      onSlideDone={() => AcceptOrder(booking.items,booking?.orderId)}
                                      hasError={!!error} // Pass error state to SlideButton
                                    />

              {/* <button type="button" onClick={() => AcceptBook(booking._id)}className="btn btn-sm mb-2 me-2 btn-primary">
                Accept <i className="ri-arrow-right-line ms-2" />
              </button> */}
            </div>
          </div>
        ))}
 </div>
 
  </div>

    <div className="toast-header align-items-center"> 
 
    <strong className="me-auto ms-2">New Request</strong>
    
       <button
      className="btn btn-danger position-relative px-1 btn-sm shadow-none px-3 py-1"
      type="button"
      onClick={CloseFoundBook} // Change onclick to onClick
      >
 Cancel 
    </button>
  </div>

</div> 
</div>
</>

    )}

</>


  )
}

export default LiveRequest
